import { createTheme } from "@mui/material/styles";
export const themeOptions = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                "*": {
                    boxSizing: "border-box",
                },
            },
        },
    },
    palette: {
        mode: "light",
        primary: {
            main: "#3f51b5",
        },
        secondary: {
            main: "#ff3b7f",
        },
    },
};
export const theme = createTheme(themeOptions);
